<template>
  <section class="image-display" v-if="imageSrc">
    <img :src="imageSrc" alt="Displayed Image" class="responsive-image" />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ImageDisplay',
  computed: {
    ...mapGetters({
      startData: 'general/getStartData',
    }),
    imageSrc() {
      if (!this.startData || !this.startData.banners) return null;
      const banner = this.startData.banners.find(
        b => b.tipo_id === 2 && b.imagem && b.imagem.url
      );
      return banner ? banner.imagem.url : null;
    },
  },
};
</script>

<style scoped>
.image-display {
  display: flex;
  justify-content: center;
  border-radius: 10px;
}

.responsive-image {
  max-width: 1200px; 
  width: 100%; 
  height: auto; 
  display: block;
  border-radius: 10px;
}
</style>
